import tarotReadingsVi from "./tarot/languages/tarot-readings-vi.json";

export const vi = {
  // Brand
  brandName: "TAROTO",

  // Navigation
  backHome: "Về Trang Chủ",
  chooseDifferentCategory: "Chọn Danh Mục Khác",

  // Home Page
  homeDescription: "Khám phá trí tuệ của những lá bài qua phép bói hiện đại",
  cardOfTheDay: "Lá Bài Trong Ngày",
  demoPage: "Trang Demo",

  // COTD Page
  cotdTitle: "Lá Bài Trong Ngày",
  cotdDescription:
    "Chọn một danh mục để tập trung vào việc đọc bài hàng ngày của bạn",

  // Categories
  categoryLove: "Tình Yêu",
  categoryWork: "Công Việc",
  categoryFriends: "Bạn Bè",
  categoryLoveDesc:
    "Hiểu biết về các mối quan hệ, tình yêu và những vấn đề của trái tim",
  categoryWorkDesc: "Hướng dẫn về sự nghiệp, dự án và thách thức nghề nghiệp",
  categoryFriendsDesc: "Hiểu về tình bạn, các kết nối xã hội và cộng đồng",

  // COTD Session
  focusLabel: "Tập trung:",
  drawPrompt: "Rút lá bài {category} của bạn để khám phá sự hướng dẫn hôm nay",
  drawPromptGeneral: "Rút lá bài của bạn để khám phá sự hướng dẫn hôm nay",
  drawCard: "Rút Bài",
  drawNewCard: "Rút Bài Mới",

  // Card Guidance
  guidanceLove:
    "Hãy xem xét cách năng lượng của lá bài này ảnh hưởng đến các mối quan hệ và kết nối tình cảm của bạn hôm nay.",
  guidanceWork:
    "Suy nghĩ về cách trí tuệ của lá bài này có thể hướng dẫn các quyết định nghề nghiệp và con đường sự nghiệp của bạn.",
  guidanceFriends:
    "Nghĩ về cách lá bài này liên quan đến tình bạn và các tương tác xã hội của bạn hôm nay.",
  guidanceGeneral:
    "Suy nghĩ về cách năng lượng của lá bài này có thể hướng dẫn ngày hôm nay của bạn.",

  // Demo Page
  demoTitle: "Demo / Phát Triển",
  componentShowcase: "Giới Thiệu Thành Phần",
  buttonsSection: "Các Nút",
  typographySection: "Kiểu Chữ",
  cardSection: "Mẫu Lá Bài",
  layoutSection: "Ví Dụ Bố Cục",
  outlineButton: "Viền",
  filledButton: "Đầy",
  heading2: "Tiêu Đề 2",
  bodyText: "Văn Bản Chính",
  secondaryText: "Văn Bản Phụ",

  readings: tarotReadingsVi,

  // Tarot Cards
  cards: {
    // Major Arcana
    "The Fool": "Khởi đầu mới, tự phát, ngây thơ",
    "The Magician": "Hiện thực hóa, tháo vát, quyền lực",
    "The High Priestess":
      "Trực giác, kiến thức thiêng liêng, nữ tính thiêng liêng",
    "The Empress": "Nữ tính, vẻ đẹp, thiên nhiên, sự dồi dào",
    "The Emperor": "Quyền uy, thể chế, cấu trúc, hình tượng cha",
    "The Hierophant": "Trí tuệ tâm linh, tín ngưỡng tôn giáo, sự tuân thủ",
    "The Lovers": "Tình yêu, hòa hợp, các mối quan hệ, sự thống nhất giá trị",
    "The Chariot": "Kiểm soát, ý chí, thành công, quyết tâm",
    Strength: "Sức mạnh, can đảm, thuyết phục, ảnh hưởng",
    "The Hermit": "Tìm kiếm tâm hồn, nội tâm, sự hướng dẫn bên trong",
    "Wheel of Fortune": "May mắn, nghiệp lực, chu kỳ cuộc sống, số phận",
    Justice: "Công bằng, sự thật, nguyên nhân và kết quả",
    "The Hanged Man": "Đình chỉ, hạn chế, buông bỏ, hy sinh",
    Death: "Kết thúc, khởi đầu, thay đổi, biến đổi",
    Temperance: "Cân bằng, điều độ, kiên nhẫn, mục đích",
    "The Devil": "Ràng buộc, nghiện, tình dục, chủ nghĩa vật chất",
    "The Tower": "Thay đổi đột ngột, biến động, hỗn loạn, sự bộc lộ",
    "The Star": "Hy vọng, đức tin, mục đích, đổi mới, tâm linh",
    "The Moon": "Ảo tưởng, sợ hãi, lo lắng, tiềm thức, trực giác",
    "The Sun": "Tích cực, vui vẻ, ấm áp, thành công, sức sống",
    Judgement: "Phán quyết, tái sinh, tiếng gọi nội tâm, tha thứ",
    "The World": "Hoàn thành, thành tựu, du lịch, viên mãn",

    // Cups
    "Ace of Cups": "Tình yêu, trực giác, kết nối tâm linh, cảm xúc mới",
    "Two of Cups": "Tình yêu thống nhất, quan hệ đối tác, sự thu hút lẫn nhau",
    "Three of Cups": "Ăn mừng, tình bạn, sáng tạo, cộng đồng",
    "Four of Cups": "Thiền định, chiêm nghiệm, thờ ơ, đánh giá lại",
    "Five of Cups": "Mất mát, hối tiếc, thất vọng, bi quan",
    "Six of Cups": "Nhìn lại quá khứ, ký ức tuổi thơ, sự ngây thơ",
    "Seven of Cups": "Cơ hội, lựa chọn, mong ước, ảo tưởng",
    "Eight of Cups": "Thất vọng, bỏ rơi, rút lui, lẩn trốn",
    "Nine of Cups": "Hài lòng, thỏa mãn, biết ơn, điều ước thành hiện thực",
    "Ten of Cups":
      "Tình yêu thiêng liêng, mối quan hệ hạnh phúc, hài hòa, thống nhất",
    "Page of Cups": "Cơ hội sáng tạo, thông điệp trực giác, tò mò",
    "Knight of Cups": "Sáng tạo, lãng mạn, quyến rũ, trí tưởng tượng",
    "Queen of Cups": "Từ bi, quan tâm, ổn định về mặt cảm xúc, trực quan",
    "King of Cups": "Cân bằng cảm xúc, từ bi, hào phóng",

    // Pentacles
    "Ace of Pentacles": "Cơ hội tài chính hoặc nghề nghiệp mới, hiện thực hóa",
    "Two of Pentacles":
      "Nhiều ưu tiên, quản lý thời gian, sắp xếp thứ tự ưu tiên",
    "Three of Pentacles": "Làm việc nhóm, hợp tác, học hỏi, thực hiện",
    "Four of Pentacles": "Tiết kiệm, an ninh, bảo thủ, tư duy khan hiếm",
    "Five of Pentacles": "Mất tài chính, nghèo đói, tư duy thiếu thốn, cô lập",
    "Six of Pentacles": "Cho và nhận, chia sẻ của cải, hào phóng",
    "Seven of Pentacles": "Tầm nhìn dài hạn, kết quả bền vững, kiên trì",
    "Eight of Pentacles":
      "Học việc, công việc lặp đi lặp lại, thành thạo, phát triển kỹ năng",
    "Nine of Pentacles": "Dồi dào, sang trọng, tự lực, độc lập tài chính",
    "Ten of Pentacles":
      "Của cải, an ninh tài chính, gia đình, thành công lâu dài",
    "Page of Pentacles": "Hiện thực hóa, cơ hội tài chính, phát triển kỹ năng",
    "Knight of Pentacles": "Làm việc chăm chỉ, năng suất, thói quen, bảo thủ",
    "Queen of Pentacles": "Nuôi dưỡng, thực tế, cung cấp tài chính, thực tế",
    "King of Pentacles":
      "Thành công tài chính, óc kinh doanh, an ninh, dồi dào",

    // Swords
    "Ace of Swords":
      "Ý tưởng mới, sự rõ ràng về tinh thần, đột phá, sức mạnh trí tuệ",
    "Two of Swords":
      "Quyết định khó khăn, cân nhắc các lựa chọn, không quyết định được, cảm xúc bị chặn",
    "Three of Swords":
      "Đau lòng, đau khổ về mặt cảm xúc, buồn bã, đau buồn, sự phản bội",
    "Four of Swords": "Nghỉ ngơi, thư giãn, thiền định, chiêm nghiệm, hồi phục",
    "Five of Swords":
      "Xung đột, bất đồng, cạnh tranh, thất bại, thắng bằng mọi giá",
    "Six of Swords":
      "Chuyển đổi, thay đổi, nghi lễ chuyển giao, buông bỏ hành lý",
    "Seven of Swords":
      "Phản bội, lừa dối, thoát khỏi điều gì đó, rút lui có chiến lược",
    "Eight of Swords":
      "Suy nghĩ tiêu cực, hạn chế tự áp đặt, giam cầm, tâm lý nạn nhân",
    "Nine of Swords": "Lo lắng, khó khăn, sợ hãi, trầm cảm, ác mộng",
    "Ten of Swords":
      "Kết thúc đau đớn, vết thương sâu, phản bội, mất mát, khủng hoảng",
    "Page of Swords":
      "Ý tưởng mới, tò mò, khát khao kiến thức, cách giao tiếp mới",
    "Knight of Swords":
      "Tham vọng, hướng hành động, thúc đẩy thành công, suy nghĩ nhanh",
    "Queen of Swords":
      "Độc lập, phán xét không thiên vị, ranh giới rõ ràng, giao tiếp trực tiếp",
    "King of Swords":
      "Sự rõ ràng về tinh thần, sức mạnh trí tuệ, quyền uy, sự thật",

    // Wands
    "Ace of Wands": "Cảm hứng, cơ hội mới, tăng trưởng, tiềm năng",
    "Two of Wands":
      "Lập kế hoạch tương lai, đưa ra quyết định, rời khỏi vùng thoải mái",
    "Three of Wands": "Mở rộng, tầm nhìn xa, cơ hội ở nước ngoài, lãnh đạo",
    "Four of Wands": "Ăn mừng, niềm vui, hài hòa, thư giãn, trở về nhà",
    "Five of Wands": "Xung đột, bất đồng, cạnh tranh, căng thẳng, đa dạng",
    "Six of Wands": "Thành công, công nhận công khai, tiến bộ, tự tin",
    "Seven of Wands": "Thách thức, cạnh tranh, bảo vệ, kiên trì",
    "Eight of Wands":
      "Chuyển động, thay đổi nhanh, hành động, liên kết, du lịch hàng không",
    "Nine of Wands":
      "Khả năng phục hồi, can đảm, kiên trì, thử thách đức tin, ranh giới",
    "Ten of Wands":
      "Gánh nặng, trách nhiệm thêm, làm việc chăm chỉ, hoàn thành",
    "Page of Wands":
      "Cảm hứng, ý tưởng, khám phá, tiềm năng vô hạn, tinh thần tự do",
    "Knight of Wands":
      "Năng lượng, đam mê, hành động có cảm hứng, phiêu lưu, bốc đồng",
    "Queen of Wands": "Can đảm, tự tin, độc lập, bướm xã hội, quyết tâm",
    "King of Wands":
      "Nhà lãnh đạo bẩm sinh, tầm nhìn, doanh nhân, danh dự, táo bạo",
  },
};
